namespace Ir.Components.General.IntroHint {

    interface IViewModel {
        hints: KnockoutObservableArray<IntroHint>;
        hint: IntroHint;
        popoverConfig: DevExpress.ui.dxPopover.Properties;
        popover: DevExpress.ui.dxPopover;
        message: KnockoutObservable<string>;
        onClick: (hint: IntroHint, vm: IViewModel) => void;
    }
    export interface IParams {
        hints: Array<IntroHint>;
    }

    let hints: KnockoutObservableArray<IntroHint> = ko.observableArray([]);

    export function showHints(hintsToShow: Array<IntroHint>) {
        // Dispose existing hints
        for (let hint of hints()) {
            hint.dispose();
        }
        hints(hintsToShow);
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        showHints(params.hints);
        self.hints = hints;
        self.message = ko.observable("");
        self.onClick = onClick.bind(null);
        self.popoverConfig = {
            position: 'top',
            width: 400,
            showTitle: true,
            title: "",
            showCloseButton: true,
            wrapperAttr: {
                class: "intro-hint-popover",
            },
            onInitialized: function (e) {
                self.popover = e.component;
            },
            onShowing(e) {
            },
            onHiding(e) {
            },
        };
    }

    function onClick(vm: IViewModel, hint: IntroHint) {
        let el = document.querySelector(hint.element);
        vm.popover.option("target", el);
        vm.popover.option("title", hint.hint);
        vm.message(hint.message);
        vm.hint = hint;
        vm.popover.option("toolbarItems", [
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'before',
                visible: vm.hint.introId !== null,
                options: {
                    text: 'Show intro tour',
                    icon: 'ms ir-live-help-icon',
                    stylingMode: 'outlined',
                    type: 'normal',
                    elementAttr: {
                        class: "intro-hint-intro",
                    },
                    onClick() {
                        vm.popover.hide();
                        vm.hint.intro.show(true);
                    },
                },
            },
            {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: 'OK',
                    icon: 'check',
                    stylingMode: 'outlined',
                    type: 'normal',
                    elementAttr: {
                        class: "intro-hint-ok",
                    },
                    onClick() {
                        vm.hint.visible(false);
                        vm.hint.save();
                        vm.popover.hide();
                    },
                },
            },
        ]);
        vm.popover.show();
    }
}